import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";

interface UploadProfileArgs {
  formData: FormData;
  onProgress?: (percent: number) => void;
}

// import { reArangeFilters } from "@/utils/helper"

// export const signIn = async (data) => {
//   try {
//     const response = await axios.post('/auth/login', data);
//     return response.data;
//   } catch (error) { }
// }

export const signIn = createAsyncThunk(
	"auth/signIn",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/auth/login", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const signUp = createAsyncThunk(
	"auth/register",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/auth/register", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const verifyOTP = createAsyncThunk(
	"auth/login/otp",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/auth/login/otp", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const requestUser = createAsyncThunk("request/user", async () => {
	try {
		const response = await axios.get("/request/user");
		return response.data;
	} catch (error: any) {
		console.log(error?.message, "error", error);
		// You can handle errors here if needed
		// return thunkAPI.rejectWithValue({ error: error.message });
	}
});

export const requestUserWithoutLoading = createAsyncThunk(
	"request/user/without/loading",
	async () => {
		try {
			const response = await axios.get("/request/user");
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			// return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const requestKycToken = createAsyncThunk(
	"request/kyc/client",
	async (clientId: any, thunkAPI) => {
		try {
			const response = await axios.get("/kyc/client/" + clientId);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			// return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const createKycCheck = createAsyncThunk(
	"check/create",
	async (payload: any, thunkAPI) => {
		try {
			const response = await axios.post("/kyc/check/create", payload);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			// return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const updateCredits = createAsyncThunk(
	"/credits/update",
	async (payload: any, thunkAPI) => {
		try {
			const response = await axios.patch("/user/credits/update", payload);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			// return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const getRetrieveKey = createAsyncThunk(
	"get/retrieveKey",
	async () => {
		try {
			const response = await axios.get("/user/wallet/retrieve");
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
		}
	}
);

export const validateSecretKeyOTP = createAsyncThunk(
	"post/user/wallet/secretKey/validate",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/user/wallet/secretKey/validate", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			// You can handle errors here if needed
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const logout = createAsyncThunk(
	"auth/logout",
	async (_, thunkAPI) => {
		try {
			const response = await axios.post("/auth/logout");
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const uploadUserProfilePic = createAsyncThunk('/asset/user/profile/upload',
	async ({ formData, onProgress }: UploadProfileArgs, { rejectWithValue }) => {
  try {
    const response = await axios.post('/asset/user/profile/upload',formData, {
			onUploadProgress: (progressEvent) => {
				const percent = Math.round(
					(progressEvent.loaded * 100) / (progressEvent.total ?? 1)
				);
				if (onProgress) {
					onProgress(Math.min(percent, 90)); 
				}
			},
		})
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
	});

	export const createDiditSession = createAsyncThunk(
		"didit/session",
		async () => {
			try {
				const response = await axios.post("/didit/session");
				return response.data;
			} catch (error: any) {
				console.log(error?.message, "error", error);
			}
		}
	);

